import { isSuccessStatus } from "./is-success-status";
import HTTP_CODES_ENUM from "./types/http-codes";
import { isJsonResponse } from "./wrapper-fetch-json-response";

export type FetchStatusResponse = { status: number };

// For endpoints that may answer a 2xx with no body, such as a DELETE. An empty 2xx is a success here,
// unlike in `wrapperFetchJsonResponse`, but a non-JSON body on a 2xx is still the Vercel challenge page,
// so it maps to SERVICE_UNAVAILABLE the same way.
async function wrapperFetchStatusResponse(response: Response | undefined): Promise<FetchStatusResponse> {
    if (!response) return { status: HTTP_CODES_ENUM.SERVICE_UNAVAILABLE };

    const { status } = response;
    if (!isSuccessStatus(status) || status === HTTP_CODES_ENUM.NO_CONTENT || isJsonResponse(response)) {
        return { status };
    }

    const body = await response.text();
    return { status: body.trim() === "" ? status : HTTP_CODES_ENUM.SERVICE_UNAVAILABLE };
}

export default wrapperFetchStatusResponse;
